// sessionCheck.js
import { firestore } from "../firebase.config";
import { collection, query, where, getDocs } from "firebase/firestore";

// sessionCheck.js

export const isAuthenticated = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const signInTime = sessionStorage.getItem("SignInTime");
  return userEmail && signInTime; // Return true if both values exist
};

// SessionStorage utilities remain the same
export const setUserEmail = (email) => {
  sessionStorage.setItem("userEmail", email);
};

export const getUserEmail = () => {
  return sessionStorage.getItem("userEmail");
};

export const clearUserEmail = () => {
  sessionStorage.removeItem("userEmail");
};

export const setUserName = (name) => {
  sessionStorage.setItem("userName", name);
};

export const getUserName = () => {
  return sessionStorage.getItem("userName");
};

export const clearUserName = () => {
  sessionStorage.removeItem("userName");
};

export const setSignInTime = (time) => {
  sessionStorage.setItem("SignInTime", time);
};

export const getSignInTime = () => {
  return sessionStorage.getItem("SignInTime");
};

export const clearSignInTime = () => {
  sessionStorage.removeItem("SignInTime");
};

// Updated check for user role in Firestore
export const setIsAdmin = async (email) => {
  try {
    const querySnapshot = await getDocs(
      query(collection(firestore, "Users"), where("userEmail", "==", email))
    );

    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0].data();
      const isAdmin = userDoc.role === "admin";
      sessionStorage.setItem("IsAdmin", isAdmin);
      return isAdmin;
    } else {
      console.error("User role check failed: User not found in Firestore.");
      sessionStorage.setItem("IsAdmin", false);
      return false;
    }
  } catch (error) {
    console.error("Error checking user role: ", error);
    sessionStorage.setItem("IsAdmin", false);
    return false;
  }
};

// Optional utility to decode JWT (if needed)
export const decodeJWT = (token) => {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1])); // Decode the payload
    return payload;
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return null;
  }
};


export const getIsAdmin = () => {
  return sessionStorage.getItem("IsAdmin") === "true"; // Ensure boolean is returned
};

export const clearIsAdmin = () => {
  sessionStorage.removeItem("IsAdmin");
};

// New functions for userId
export const setUserId = (userId) => {
  sessionStorage.setItem("userId", userId);
};

export const getUserId = () => {
  return sessionStorage.getItem("userId");
};

export const clearUserId = () => {
  sessionStorage.removeItem("userId");
};
